import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import ChatPage from "@/pages/ChatPage";
import SourceLightboxHarness from "@/pages/SourceLightboxHarness";
import "./index.css";

const params = new URLSearchParams(window.location.search);
const useSourceLightboxHarness =
  params.get("harness") === "source-lightbox" || import.meta.env.MODE === "uat";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {useSourceLightboxHarness ? <SourceLightboxHarness /> : <ChatPage />}
  </StrictMode>,
);
